// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ocHn","content":"styles_content__1TO7z"};